export interface SummaryLiteData {
  title: string;
  subtitle?: string;
  priceDetail: PriceDetailSummaryLite;
  deducible?: string;
  coveragesSections?: CoveragesSectionSummaryLite[];
  summarySections?: SectionSummaryLite[];
}

export interface PriceDetailSummaryLite {
  price: string;
  frequency: string;
  currency: string;
}

export interface CoveragesSectionSummaryLite {
  title: string;
  coverages?: CoverageSummaryLite[];
}

export interface CoverageSummaryLite {
  name: string;
  value: string;
}

export interface SectionSummaryLite<E = unknown> {
  id: SectionIdSummaryLite;
  title: string;
  isExpanded: boolean;
  icon?: string;
  subSections: SubSectionSummaryLite<E>[];
}

interface BaseSubSectionSummaryLite {
  id: SubSectionIdSummaryLite;
  title?: string;
}

type WithExtras<TRequired, TValue = unknown> = TRequired & Omit<Record<string, TValue>, keyof TRequired>;

export type SubSectionSummaryLite<E = unknown> = WithExtras<BaseSubSectionSummaryLite, E>;

export const SectionIdSummaryLite = {
  POLICYHOLDER: 'POLICYHOLDER',
  PREV_INSURANCE: 'PREV_INSURANCE',
  PAYMENT: 'PAYMENT',
} as const;
export type SectionIdSummaryLite = (typeof SectionIdSummaryLite)[keyof typeof SectionIdSummaryLite];

export const SubSectionIdSummaryLite = {
  POLICYHOLDER: 'POLICYHOLDER',
  FAMILY: 'FAMILY',
  PREVIOUS_INSURANCE: 'PREVIOUS_INSURANCE',
  PAYMENT: 'PAYMENT',
} as const;
export type SubSectionIdSummaryLite = (typeof SubSectionIdSummaryLite)[keyof typeof SubSectionIdSummaryLite];
